<template>
  <section class="d-flex flex-wrap align-items-center" style="gap: 0.4rem;">
    <span
      v-for="(tag, index) in value"
      :key="index"
      class="tag-pill"
      :style="{ backgroundColor: tag.bg, color: tag.color }"
    >
      {{tag.text}}
    </span>
  </section>
</template>

<script>
  export default {
    name: "itemOptions",
    props: {
      value: {
        required: true,
        type: Array
      }
    }
  }
</script>

<style scoped>
  .tag-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem 0.7rem;
    border-radius: 999px;
    font-size: 0.7rem;
    font-weight: bold;
    line-height: 1;
    white-space: nowrap;
  }
</style>
